import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { CONSUMER_CELL_MONO } from 'components/consumer/consumer-list-styles';

type ConsumerUuidCellProps = {
  value?: string | null;
  fallback?: string | number | null;
  label?: string;
};

function displayValue(value?: string | null, fallback?: string | number | null): string {
  if (value?.trim()) return value.trim();
  if (fallback != null && String(fallback).trim()) return String(fallback).trim();
  return '—';
}

const ConsumerUuidCell: React.FC<ConsumerUuidCellProps> = ({
  value,
  fallback,
  label = 'ID',
}) => {
  const [copied, setCopied] = useState(false);
  const full = displayValue(value, fallback);
  const canCopy = full !== '—';

  const copyId = async () => {
    if (!canCopy) return;
    try {
      await navigator.clipboard.writeText(full);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      /* clipboard unavailable */
    }
  };

  return (
    <div className="inline-flex items-center gap-1.5">
      <span className={CONSUMER_CELL_MONO}>{full}</span>
      {canCopy && (
        <button
          type="button"
          onClick={() => void copyId()}
          title={copied ? 'Copied' : `Copy ${label}`}
          aria-label={copied ? `Copied ${label}` : `Copy ${label}`}
          className="shrink-0 p-1 rounded-md text-faint hover:text-heading hover:bg-subtle transition-colors"
        >
          {copied ? (
            <Check size={14} strokeWidth={2.5} className="text-emerald-600" />
          ) : (
            <Copy size={14} strokeWidth={2} />
          )}
        </button>
      )}
    </div>
  );
};

export default ConsumerUuidCell;
